
import React from "react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

interface ProductTest {
  id: string;
  name: string;
  date: string;
  glycemicIndex: number;
  glucoseSpike: string;
  satiety: number;
}

interface ParticipantProductTestsProps {
  productTests: ProductTest[];
  title?: string;
  showGlycemicIndex?: boolean;
  showGlucoseSpike?: boolean;
  showSatiety?: boolean;
}

const ParticipantProductTests: React.FC<ParticipantProductTestsProps> = ({
  productTests,
  title = "Product Tests",
  showGlycemicIndex = true,
  showGlucoseSpike = true,
  showSatiety = true
}) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>{title}</CardTitle>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Test Meal</TableHead>
              <TableHead>Test Date/Time</TableHead>
              {showGlycemicIndex && <TableHead>GI Score</TableHead>}
              {showGlucoseSpike && <TableHead>Glucose Spike</TableHead>}
              {showSatiety && <TableHead>Satiety Level</TableHead>}
            </TableRow>
          </TableHeader>
          <TableBody>
            {productTests.map((test) => (
              <TableRow key={test.id}>
                <TableCell className="font-medium">{test.name}</TableCell>
                <TableCell>{test.date}</TableCell>
                {showGlycemicIndex && <TableCell>{test.glycemicIndex}</TableCell>}
                {showGlucoseSpike && <TableCell>{test.glucoseSpike ? test.glucoseSpike : '-'}</TableCell>}
                {showSatiety && <TableCell>{test.satiety ? `${test.satiety}/5` : '-'}</TableCell>}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};

export default ParticipantProductTests;
